import * as React from "react";
import styled from "styled-components";
import Alink from "@/component/Alink";
import { usePage } from "@/component/PageControl";

const LeftContainer = styled.div`
  width: 200px;
  height: 94%;
  background: #fff;
  border: 1px solid #eee;
  box-sizing: border-box;
  margin-top: 3%;
  border-radius: 3px;
  transition: all 0.3s;
  .slink {
    padding: 6px;
    display: block;
    &:hover {
      background: rgba(24, 144, 255, 0.4);
      /* color: white; */
    }
  }
  .active {
    background: #1890ff !important;
    color: white;
  }
`;

const ___navlinks = [
  { to: "/setting/normal", txt: "常规" },
  // { to: "/setting/video", txt: "视频" },
  // { to: "/setting/audio", txt: "音频" },
  // { to: "/setting/network", txt: "网络" },
  // { to: "/setting/meeting", txt: "个人会议号" },
  // { to: "/setting/env", txt: "环境" },
];

const SettingLeft: React.FunctionComponent = () => {
  const page = usePage();
  const { currentLink } = page;

  return (
    <LeftContainer>
      {___navlinks.map((t) => (
        <div className="at" key={t.to}>
          <Alink
            className="slink"
            key={t.to}
            to={t.to}
            disabled={false}
            active={currentLink === t.to}
          >
            {t.txt}
          </Alink>
        </div>
      ))}
    </LeftContainer>
  );
};

export default SettingLeft;
